import { Stack, Typography, Chip, Box } from "@mui/material";
import React from "react";
import { FC } from "react";


export interface ChipItem {
  id: any,
  label: string,
  content: string,
  delete: ()=>void,
}

const SearchCriteriaChips: FC<{criteriaChips:ChipItem[][]}> = ({criteriaChips}) => {
  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" sx={{ p: 2 }}>
      {criteriaChips.map((arr, i) => (
        <React.Fragment key={i}>
          {i > 0 &&
            <Typography variant="caption" color="InactiveCaptionText" sx={{ mx: 0.75 }}>- and -</Typography>}
          {arr.map((c,j) => (
            <React.Fragment key={j}>
              <Chip 
                key={c.id}
                label={(
                  <Stack direction="row" alignItems="center" sx={{ '& span': {fontWeight: 600}}}>
                    <span>{c.label}</span>
                    :{' '}
                    {c.content}
                  </Stack>
                )}
                onDelete={c.delete}
                sx={{ m: 1 }}
                variant="outlined"
              />
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
      {criteriaChips.length === 0 &&
        <Box sx={{ p: 1 }}>
          <Typography
            component="span"
            color="InactiveCaptionText"
            variant="subtitle2"
          >
            No filters applied
          </Typography>
        </Box>}
    </Stack>
  )
}

export default SearchCriteriaChips;
